import { HydratedRouter } from "react-router/dom";
import { startTransition, StrictMode, useEffect } from "react";
import {
  useLocation,
  createRoutesFromChildren,
  useNavigationType,
  matchRoutes,
} from "react-router";
import * as Sentry from "@sentry/react";
import { hydrateRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client/react";
import { getServerClient } from "./graphql";

if (webConfig.environment === "production") {
  Sentry.init({
    dsn: "https://e597eb6cd3f80dc37b2bdba28ff2c0b7@o457803.ingest.us.sentry.io/4508953849495552",
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: webConfig.environment,
    release: webConfig.revision,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    // ...
  });
}

function eventHandler(event: any) {
  try {
    event.preventDefault();
    installPrompt = event;
  } catch (error) {
    console.error(error);
  }
}

window.addEventListener("beforeinstallprompt", eventHandler);

startTransition(() => {
  const client = getServerClient();
  hydrateRoot(
    document,
    <StrictMode>
      <ApolloProvider client={client}>
        <HydratedRouter />
      </ApolloProvider>
    </StrictMode>,
  );
});
